import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import useTagsCompatibilityDisplay from 'hooks/useTagsCompatibilityDisplay';
import parentStyles from '../../utils/parentStyles';

const styles = StyleSheet.create({
  tagsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 4,
    marginBottom: 4
  },
  tag: {
    borderRadius: 4,
    marginRight: 4,
    marginBottom: 4,
    padding: '1px 4px',
    fontFamily: 'Noto Sans',
    fontSize: 10,
    fontWeight: 600
  }
});

interface Tag {
  id: string;
  name: string;
  color: string;
  description?: string;
}

interface TagsProps {
  title: string;
  tags?: Tag[];
}

const Tags: React.FC<TagsProps> = ({ tags = [], title = 'Tags' }) => {
  const enhancedTags = useTagsCompatibilityDisplay(tags);

  if (!enhancedTags || enhancedTags.length === 0) {
    return null;
  }

  return (
    <View wrap={false}>
      <Text style={parentStyles.title} fixed>
        {title}
      </Text>
      <View style={styles.tagsContainer}>
        {enhancedTags.map(tag => (
          <View
            key={tag.id}
            style={[
              styles.tag,
              {
                backgroundColor: tag.backgroundColor,
                color: tag.textColor
              }
            ]}
          >
            <Text>{tag.name}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default Tags;
